<template>
  <div class="form-group">
    <b-form-select class="form-control form-control-lg text-center"
                   v-model="question.GivenAnswer">
        <option :value="null"
                disabled>
            <p>Please select an option</p>
        </option>
        <option v-for="(option,index) in question.PossibleAnswersAsArray"
                :key="index"
                :value="option.Value">
            {{ option.Text }}
        </option>
    </b-form-select>
  </div>
</template>

<script>
  export default {
    props: {
      question: {
        required: true,
        type: Object,
      },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/surveys/types/Options.vue